module.exports = __webpack_public_path__ + "static/media/logo-mini.14480932.png";